/* ================================================================
   HUNIWEAR — PRODUCT PAGE (CONVERSION TEMPLATE) JS
   Scope: only the new UI pieces below. This file NEVER re-implements
   variant selection, price updates, or add-to-cart — that logic stays
   100% inside the theme's own assets/product.js and the native
   `{% form 'product' %}`. It listens to the native form's `change`
   event and reads variant data from the theme's own, already-rendered
   `.product-json` script (see snippets/product-json.liquid) — no
   duplicate data source, no polling, no MutationObserver hacks.
   ================================================================ */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function readProductJson() {
    var el = document.querySelector('.product-json');
    if (!el) { return null; }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSelectedOptionValues(form) {
    var values = [];
    var controls = form.querySelectorAll('[name^="options["]');
    var seen = {};
    controls.forEach(function (control) {
      var name = control.getAttribute('name');
      if (control.tagName === 'SELECT') {
        seen[name] = control.value;
      } else if (control.type === 'radio' || control.type === 'checkbox') {
        if (control.checked) { seen[name] = control.value; }
      }
    });
    // Preserve product.options order using the option index embedded in
    // each dropdown's id (Option-{{ section.id }}-{{ forloop.index0 }}),
    // falling back to object insertion order for swatches.
    var dropdowns = Array.prototype.slice.call(form.querySelectorAll('select[id^="Option-"]'));
    if (dropdowns.length > 0) {
      dropdowns.sort(function (a, b) {
        var ai = parseInt(a.id.split('-').pop(), 10);
        var bi = parseInt(b.id.split('-').pop(), 10);
        return ai - bi;
      });
      values = dropdowns.map(function (d) { return d.value; });
    } else {
      Object.keys(seen).forEach(function (key) { values.push(seen[key]); });
    }
    return values;
  }

  function findVariantByOptions(productData, selectedValues) {
    if (!productData || !productData.variants) { return null; }
    return productData.variants.find(function (variant) {
      var opts = variant.options || [];
      return selectedValues.every(function (val, i) { return opts[i] === val; });
    }) || null;
  }

  /* ── Inventory + shipping status ──────────────────────────────── */
  function initStock(el, productData) {
    var formId = el.getAttribute('data-hw-pdp-stock-form');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) { return; }

    var textEl = el.querySelector('[data-hw-pdp-stock-text]');
    var shippingEl = el.querySelector('[data-hw-pdp-shipping-text]');
    var dotEl = el.querySelector('.hw-pdp-stock__dot');
    var textAvailable = el.getAttribute('data-hw-pdp-text-available');
    var textUnavailable = el.getAttribute('data-hw-pdp-text-unavailable');

    function update() {
      var values = getSelectedOptionValues(form);
      var variant = findVariantByOptions(productData, values);
      if (!variant) { return; }
      var available = !!variant.available;

      if (textEl) { textEl.textContent = available ? textAvailable : textUnavailable; }
      if (dotEl) { dotEl.classList.toggle('hw-pdp-stock__dot--off', !available); }
      if (shippingEl) {
        if (available) { shippingEl.removeAttribute('hidden'); }
        else { shippingEl.setAttribute('hidden', ''); }
      }
    }

    form.addEventListener('change', update);
  }

  /* ── Judge.me preview badge → scroll to full review widget ──────── */
  function initReviewScroll() {
    var badgeContainers = document.querySelectorAll('.product__section--app');
    badgeContainers.forEach(function (container) {
      var badge = container.querySelector('.jdgm-prev-badge');
      if (!badge) { return; }
      badge.style.cursor = 'pointer';
      badge.addEventListener('click', function () {
        var target = document.querySelector('.jdgm-widget, #judgeme_product_reviews, .jdgm-review-widget');
        if (!target) { return; }
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  }

  /* ── Mobile sticky add-to-cart bar ──────────────────────────────── */
  function initStickyCart(el, productData) {
    var observeTargetId = el.getAttribute('data-hw-pdp-sticky-observe-target');
    var observeTarget = observeTargetId ? document.getElementById(observeTargetId) : null;
    var realButtonFormId = el.getAttribute('data-hw-pdp-sticky-real-button-form');
    var realForm = realButtonFormId ? document.getElementById(realButtonFormId) : null;
    var realButton = realForm ? realForm.querySelector('button[type="submit"][name="add"]') : null;
    var variantForm = document.querySelector('[id^="product-form-"]');

    if (!observeTarget || !realButton) { return; }

    var variantEl = el.querySelector('[data-hw-pdp-sticky-variant]');
    var priceEl = el.querySelector('[data-hw-pdp-sticky-price]');
    var triggerBtn = el.querySelector('[data-hw-pdp-sticky-trigger]');
    var triggerText = el.querySelector('[data-hw-pdp-sticky-btn-text]');

    function formatMoney(cents) {
      // Best-effort fallback formatter; the theme's own Shopify.formatMoney
      // is used when available so currency formatting stays consistent.
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
        return Shopify.formatMoney(cents, window.theme.moneyFormat);
      }
      return (cents / 100).toFixed(2);
    }

    function syncVariant() {
      if (!variantForm) { return; }
      var values = getSelectedOptionValues(variantForm);
      var variant = findVariantByOptions(productData, values);
      if (!variant) { return; }

      if (variantEl) { variantEl.textContent = variant.title; }
      if (priceEl) { priceEl.textContent = formatMoney(variant.price); }

      var available = !!variant.available;
      if (triggerBtn) { triggerBtn.disabled = !available; }
      if (triggerText) {
        triggerText.textContent = available
          ? (window.theme && window.theme.strings && window.theme.strings.addToCart) || triggerText.textContent
          : triggerText.textContent;
      }
    }

    if (variantForm) { variantForm.addEventListener('change', syncVariant); }

    if (triggerBtn) {
      triggerBtn.addEventListener('click', function () {
        // Proxy-click the real, native Add to Cart button rather than
        // submitting a second form — keeps Kaching Bundles and the
        // native AJAX cart flow as the single source of truth.
        realButton.click();
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            el.setAttribute('hidden', '');
          } else {
            el.removeAttribute('hidden');
          }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      observer.observe(observeTarget);
    }
  }

  function init() {
    var productData = readProductJson();

    document.querySelectorAll('[data-hw-pdp-stock]').forEach(function (el) {
      initStock(el, productData);
    });

    initReviewScroll();

    document.querySelectorAll('[data-hw-pdp-sticky-cart]').forEach(function (el) {
      initStickyCart(el, productData);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
